import React, { useEffect, useState } from "react";
import copy from "copy-to-clipboard";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
  Card,
  CardBody,
  CardTitle,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import SvgImage from "../../Icons/Icons";
import { useNavigate } from "react-router-dom";
import {
  cashbackRequestClaimRequestAction,
  clearCashbackList,
  clearTransactionDetails,
  getCardTransactionDetails,
  getCardTransactionSlipPdf,
  getCashbacklist,
  getFastagTransactionDetails,
  getFastagTransactionSlipPdf,
  getFastagWalletTransactionDetails,
  getFastagWalletTransactionSlipPdf,
  getTransactionDetails,
  getTransactionSlipPdf,
  getCardWalletTxnSlip,
  downloadCardWalletTxnSlipPdf,
  saveSlipAction,
} from "../../../services/Store/Actions/walletAction";
import { getSignedUrlApiAction, storeMedia } from "../../../services/Store/Actions/appActions";
import SvgImage2 from "../../Icons/Icon2";
import { Formik } from "formik";
import ImageModal from "../../VehicleProfile/imageModal";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
// import Base64 from 'Base64';
function TransactionSlip(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    toggleModal,
    open,
    closeModal,
    path,
    transactionId,
    setTransactionId,
  } = props;
  const {
    transactionSlip,
    loader: documentLoader,
    cashbackList,
  } = useSelector((state) => state?.wallet);
  const [images, setImages] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [imageLoader, setImageLoader] = useState(false);
  const [displayName, setDisplayName] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const closeImageModal = () => {
      setImageModal(false);
  };
  const toggleImageModal = () => {
      setImageModal(!imageModal);
  }
  const { chargebackStatus } = useSelector((state) => state?.fastag);
  const [receipt, setReceipt] = useState("");
  console.log(
    "TransactionSlipTransactionSlipTransactionSlip",
    open,
    transactionId,
    path
  );

  useEffect(() => {
    console.log("TransactionSlipuseEffectuseEffectuseEffect", transactionId);
    if (transactionId) {
      if (path == "MasterAccount") {
        dispatch(getTransactionDetails(transactionId));
      } else if (path == "FastagWallet") {
        dispatch(getFastagWalletTransactionDetails(transactionId));
      } else if (path == "FastagVehicle") {
        dispatch(getFastagTransactionDetails(transactionId));
      } else if (path == "YesbankCard") {
        dispatch(
          getCardTransactionDetails(transactionId, (res) => {
            console.log("svhsvsvvsvsvs", res);
          })
        );
      }else if (path == "CardWallet") {
        console.log("CardWalletCardWalletCardWallet");
        dispatch(getCardWalletTxnSlip({transactionId}, (res) => {console.log("getCardWalletTxnSlipgetCardWalletTxnSlip",res);}));
      } else {
        // ToastAndroid.show('Please Try again', ToastAndroid.SHORT);
      }
      return () => {
        dispatch(clearTransactionDetails());
      };
    }
  }, [transactionId]);
  console.log("--------------------------------3", images);
  useEffect(() => {
    if (transactionSlip?.docUrl) {
      if (
        transactionSlip?.docUrl.length > 0 &&
        typeof transactionSlip?.docUrl == "object"
      ) {
        let images1 = [];
        transactionSlip?.docUrl.map((value, index) => {
          console.log("valuesss", value);
          dispatch(
            getSignedUrlApiAction({ key: value }, (res) => {
              console.log("--------SINGEDKEY", res?.data);
              if (res?.status == 200) {
                images1.push(res.data.data);
              }
            })
          );
        });
        console.log("--------------------------------", images);
        setImages(images1);
        console.log("--------------------------------2", images);
      } else {
        dispatch(
          getSignedUrlApiAction({ key: transactionSlip?.docUrl }, (res) => {
            console.log("--------SINGEDKEY", res?.data);
            if (res?.status == 200) {
              setReceipt(res?.data?.data);
            }
          })
        );
      }
    }
  }, [transactionSlip, transactionId]);
  const documentId = "transactionSlipModal"
  const notify =  (msg, isError = false) => {
    console.log("ajshgvdkba");
    if(isError){
        toast.error(msg || "failed", {
            toastId: documentId,
        })
    }else{
        toast.success(msg || "success", {
            toastId: documentId,
        })
    }
   
}
 const downloadSlip = () => {
  if (path == 'MasterAccount') {
    dispatch(
      getTransactionSlipPdf(
        transactionId,
        res => {
          console.log("MasterAccountMasterAccountMasterAccountMasterAccount",res);
          if (res) {
            window.open("data:application/octet-stream;charset=utf-16le;base64,"+res)
          }
        },
      ),
    );
  } else if (path == 'FastagWallet') {
    dispatch(
      getFastagWalletTransactionSlipPdf(
        transactionId,
        res => {
          if (res) {
            window.open("data:application/octet-stream;charset=utf-16le;base64,"+res)
          }
        },
      ),
    );
  } else if (path == 'FastagVehicle') {
    dispatch(
      getFastagTransactionSlipPdf(
        transactionId,
        res => {
          console.log(res);
          if (res) {
            window.open("data:application/octet-stream;charset=utf-16le;base64,"+res)
          }
        },
      ),
    );
  } else if (path == 'YesbankCard') {
    dispatch(
      getCardTransactionSlipPdf(
        transactionId,
        res => {
          console.log(res);
          if (res) {
            window.open("data:application/octet-stream;charset=utf-16le;base64,"+res)
          }
        },
      ),
    );
  }
  else if (path == 'CardWallet') {
    dispatch(
      downloadCardWalletTxnSlipPdf(
        {transactionId},
        res => {
          console.log(res);
          if (res) {
            window.open("data:application/octet-stream;charset=utf-16le;base64,"+res)
          }
        },
      ),
    );
  } else {
    notify('Please Try Again', true);
  }
 }
  const FastagIocns = ({ mode }) => {
    console.log("THIS IS MODE HERER", mode);

    return (
      <>
        {mode == "toll" ? (
          <SvgImage2
            name="SlipToll"
            width={48}
            height={48}
            viewBox="0 0 48 48"
            style={{ alignSelf: "center" }}
          />
        ) : mode == "tag issue" ? (
          <SvgImage2
            name="SlipTagIssuance"
            width={48}
            height={34}
            viewBox="0 0 48 34"
            style={{ alignSelf: "center" }}
          />
        ) : (
          <SvgImage2
            name="TransactionSlipFastag"
            width={66}
            height={14}
            viewBox="0 0 66 14"
            style={{ alignSelf: "center" }}
          />
        )}
      </>
    );
  };

  const FastagWalletIocns = ({ mode }) => {
    return (
      <>
        {mode == "tag issue" || mode == "tag reissue" ? (
          <SvgImage2
            name="SlipTagIssuance"
            width={48}
            height={34}
            viewBox="0 0 48 34"
            style={{ alignSelf: "center" }}
          />
        ) : mode == "auto recharge" ? (
          <SvgImage2
            name="TransactionSlipFastag"
            width={66}
            height={14}
            viewBox="0 0 66 14"
            style={{ alignSelf: "center" }}
          />
        ) : mode == "master account" ? (
          <SvgImage2
            name="TransactionSlipMa"
            width={48}
            height={48}
            viewBox="0 0 48 48"
            style={{ alignSelf: "center" }}
          />
        ) : (
          <SvgImage2
            name="SlipFastagWallet"
            width={42}
            height={38}
            viewBox="0 0 42 38"
            style={{ alignSelf: "center" }}
          />
        )}
      </>
    );
  };
  return (
    <div>
      <Modal
        isOpen={open}
        onHide={closeModal}
        className=" modal-dialog-centered model-width-addFund"
        toggle={closeModal}
        aria-labelledby="myModalLabel2"
      >
        <ModalBody className="transactionModalBody">
          <div className="closeBtnWithBackground" onClick={closeModal}>
            <SvgImage
              classname="close-fund-btn-text"
              style={{ width: "10%", height: "10%" }}
              name="crossBtnWIthBackground"
              width="20%"
              height="20%"
            />
          </div>

          <div style={{ marginTop: " 10px", marginBottom: "0px", marginRight: "40px"  }}>
            <div className="textDiv">
              <div
                className="PGCollectiontText col-10"
                style={{ marginLeft: "24px" }}
              >
                Transaction Slip
              </div>
              <div className="textDiv" onClick={downloadSlip} >
                <div className="textDark" style={{paddingTop: "3px" }}>Download</div>
                <div className="padding8L" >
                <SvgImage name="downloadImg" />
                </div>
              </div>
            
            </div>
          </div>
          
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              height: "375px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "90%"
              }}
            >
              <div
                className="TransactionSlipCard"
              // style={{
              //   height: "74px",
              //   width: "74px",
              //   justifyContent: "center",
              //   backgroundColor: "rgba(213, 229, 229, 0.25)",
              //   border: "1px solid orange",
              //   borderRadius: "50%",
              //   marginTop: "28px",
              //   marginBottom: "18px",
              // }}
              >
                {path == "FastagVehicle" ? (
                  <div style={{ alignItems: "center" }}>
                    <FastagIocns mode={transactionSlip?.mode} />
                  </div>
                ) : path == "FastagWallet" ? (
                  <FastagWalletIocns
                    mode={transactionSlip?.mode?.toLowerCase()}
                  />
                ) : path == "MasterAccount" ? (
                  // ? transactionSlip.transferType == 1 || transactionSlip.transferType == 2 || transactionSlip.transferType == 7|| transactionSlip.transferType == 9
                  //   ? <SvgImage2
                  //     name='TransactionSlipMa'
                  //     width={48}
                  //     height={48}
                  //     viewBox="0 0 48 48"
                  //     style={{ alignSelf: 'center' }}
                  //   /> :
                  transactionSlip?.transferType == 3 ? (
                    <SvgImage2
                      name="TransactionSlipCard"
                      width={48}
                      height={48}
                      viewBox="0 0 48 48"
                      style={{ alignSelf: "center", marginTop: "6px" }}
                    />
                  ) : transactionSlip?.transferType == 2 ? (
                    <SvgImage2
                      name="SlipUPI"
                      width={36}
                      height={48}
                      viewBox="0 0 36 48"
                      style={{ alignSelf: "center", marginTop: "6px" }}
                    />
                  ) : transactionSlip?.transferType == 5 ||
                    transactionSlip?.transferType == 10 ? (
                    <SvgImage2
                      name="SlipLogipeWithDrawal"
                      width={45}
                      height={40}
                      viewBox="0 0 45 40"
                      style={{ alignSelf: "center" }}
                    />
                  ) : transactionSlip?.transferType == 6 ||
                    transactionSlip?.transferType == 16 ? (
                    <SvgImage2
                      name="SlipFastagWallet"
                      width={42}
                      height={38}
                      viewBox="0 0 42 38"
                      style={{ alignSelf: "center" }}
                    />
                  ) : transactionSlip?.transferType == 25 ? (
                    <SvgImage2
                      name="SlipCardIsuance"
                      width={48}
                      height={48}
                      viewBox="0 0 48 48"
                      style={{ alignSelf: "center" }}
                    />
                  ) : transactionSlip?.transferType == 29 ? (
                    <SvgImage2
                      name="SlipSubscription"
                      width={48}
                      height={48}
                      viewBox="0 0 48 48"
                      style={{ alignSelf: "center" }}
                    />
                  ) : transactionSlip?.transferType == 31 ? (
                    <SvgImage2
                      name="SlipInsurance"
                      width={48}
                      height={41}
                      viewBox="0 0 48 41"
                      style={{ alignSelf: "center" }}
                    />
                  ) : transactionSlip?.transferType == 30 ? (
                    <SvgImage2
                      name="SlipLogiMart"
                      width={48}
                      height={48}
                      viewBox="0 0 48 48"
                      style={{ alignSelf: "center" }}
                    />
                  ) : (
                    <SvgImage2
                      name="TransactionSlipMa"
                      width={48}
                      height={48}
                      viewBox="0 0 48 48"
                      style={{ alignSelf: "center" }}
                    />
                  )
                ) : path == "YesbankCard" || path == "M2P" ? (
                  transactionSlip?.channel?.toLowerCase() == "pos" ||
                  transactionSlip?.channel?.toLowerCase() == "pos withdrawl" ? (
                    <SvgImage2
                      name="SlipPos"
                      width={30}
                      height={46}
                      viewBox="0 0 30 46"
                      style={{ alignSelf: "center" }}
                    />
                  ) : transactionSlip?.channel?.toLowerCase() == "atm" ? (
                    <SvgImage2
                      name="SlipAtm"
                      width={32}
                      height={46}
                      viewBox="0 0 32 46"
                      style={{ alignSelf: "center" }}
                    />
                  ) : (
                    <SvgImage2
                      name="TransactionSlipCard"
                      width={48}
                      height={48}
                      viewBox="0 0 48 48"
                      style={{ alignSelf: "center" }}
                    />
                  )
                ) : path == "CardWallet" ? (
                  transactionSlip?.transactionType == "debit" ? (
                    <SvgImage2
                      name="TransactionSlipCard"
                      width={48}
                      height={48}
                      viewBox="0 0 48 48"
                      style={{ alignSelf: "center", marginTop: "6px" }}
                    />
                  ) : transactionSlip?.transactionType == "credit" ? (
                    <SvgImage2
                      name="TransactionSlipMa"
                      width={48}
                      height={48}
                      viewBox="0 0 48 48"
                      style={{ alignSelf: "center" }}
                    />
                ) : (
                  <></>
                )): (
                  <></>
                )}
              </div>
              <div
                style={{
                  color: transactionSlip?.transactionType == "credit" ? "#07be7a" : "#fe2950",
                  fontWeight: "900",
                  fontSize: "21px",
                }}
              >
                ₹ {transactionSlip.amount}
              </div>
              <div className="StatusCard"
                style={{
                  backgroundColor: transactionSlip?.status == '3' ||
                  transactionSlip?.status == '5'
                  ? 'rgba(230, 57, 70, 0.1)'
                  : transactionSlip?.status == '0' ||
                    transactionSlip?.status == '1'
                    ? 'rgba(250, 199, 56, 0.1)'
                    : '#F0FEF7',
                  borderRadius: "12px",
                  paddingHorizontal: "6px",
                  paddingVertical: "10px",
                }}
              >
                <div>
                    {transactionSlip?.status == '0' ? (
                    <SvgImage2
                      name="PendingYellow"
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                    />
                  ) : transactionSlip?.status == '1' ? (
                    <SvgImage2
                      name="PendingYellow"
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                    />
                  ) : transactionSlip?.status == '2' ? (
                    <SvgImage2
                      name="Completed"
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                    />
                  ) : transactionSlip?.status == '3' ||
                    transactionSlip?.status == '5' ? (
                    <SvgImage2
                      name="Failed"
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                    />
                  ) : transactionSlip?.status == '6' ? (
                    <SvgImage2
                      name="Completed"
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                    />
                  ) : (
                    <SvgImage2
                      name="Completed"
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                    />
                  )}
                </div>
              
              <div
                style={{
                    font: "Nunito-Bold",
                    paddingLeft: "6px",
                    paddingRight: "6px",
                    fontSize: "12px",
                    lineHeight: "16.37px",
                    paddingTop: "5px",
                    color:
                      transactionSlip?.status == '0'
                        ? '#FAC738'
                        : transactionSlip?.status == '1'
                          ? '#FAC738'
                          : transactionSlip?.status == '2'
                            ? '#09BD7B'
                            : transactionSlip?.status == '3'
                              ? '#E63946'
                              : transactionSlip?.status == '5'
                                ? '#E63946'
                                : transactionSlip?.status == '6'
                                  ? '#09BD7B'
                                  : '#09BD7B',
                  }
                }>
                {transactionSlip?.status == '0'
                  ? 'Intiated '
                  : transactionSlip?.status == '1'
                    ? 'Pending '
                    : transactionSlip?.status == '2'
                      ? 'Completed '
                      : transactionSlip?.status == '3'
                        ? 'Failed '
                        : transactionSlip?.status == '5'
                          ? 'Rejected '
                          : transactionSlip?.status == '6'
                            ? 'Reversed '
                            : 'Completed '}
                             <span >
                  on{" "}
                </span>
                <span>
                  {" "}
                  {transactionSlip.transactionDate}
                </span>
              </div>
               
              </div>
              <div className="slipCard">
                {transactionSlip?.from ? (
                  <div className="textDiv"> <span className="textLight">From -</span> <span className="textDark">{transactionSlip.from}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.to ? (
                  <div className="textDiv" > <span className="textLight">To -</span> <span className="textDark">{transactionSlip.to}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.upiId ? (
                  <div  className="textDiv"> <span className="textLight">UPI Id - </span> <span className="textDark">{transactionSlip.upiId}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.transactionId ? (
                  <div  className="textDiv"> <span className="textLight">TransactionId Id - </span> <span className="textDark">{transactionSlip.transactionId}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.vrn ? (
                  <div  className="textDiv"> <span className="textLight">Vehicle Number - </span> <span className="textDark">{transactionSlip.vrn}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.referenceId ? (
                  <div  className="textDiv"> <span className="textLight">Bank Ref Id - </span> <span className="textDark">{transactionSlip.referenceId}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.utr ? (
                  <div className="textDiv" > <span className="textLight">UTR Number - </span> <span className="textDark">{transactionSlip.utr}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.refundTxnId ? (
                  <div  className="textDiv"> <span className="textLight">Refund Txn Id - </span> <span className="textDark">{transactionSlip.refundTxnId}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.tagId ? (
                  <div  className="textDiv"> <span className="textLight">FastTag Id - </span> <span className="textDark">{transactionSlip.tagId}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.vehicleCategory ? (
                  <div className="textDiv" > <span className="textLight">Vehicle Category - </span> <span className="textDark">{transactionSlip.vehicleCategory}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.tollID ? (
                  <div  className="textDiv"> <span className="textLight">Toll Id - </span> <span className="textDark">{transactionSlip.tollID}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.tollName ? (
                  <div  className="textDiv"> <span className="textLight">Toll Name - </span> <span className="textDark">{transactionSlip.tollName}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.merchantName ? (
                  <div  className="textDiv"> <span className="textLight">Merchant Name - </span> <span className="textDark">{transactionSlip.merchantName}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.itemName ? (
                  <div className="textDiv" > <span className="textLight">Item Name - </span> <span className="textDark">{transactionSlip.itemName}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.quantity ? (
                  <div  className="textDiv"> <span className="textLight">Quantity - </span> <span className="textDark">{transactionSlip.quantity}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.insuranceId ? (
                  <div className="textDiv" > <span className="textLight">Insurance Id - </span> <span className="textDark">{transactionSlip.insuranceId}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.cardNo ? (
                  <div className="textDiv" > <span className="textLight">Card No - </span> <span className="textDark">{transactionSlip.cardNo}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.mrn ? (
                  <div className="textDiv" > <span className="textLight">MRN - </span> <span className="textDark">{transactionSlip.mrn}</span></div>
                ) : (
                  <></>
                )}
                {transactionSlip?.txnRefNoPos ? (
                  <div onPress={() => {
                    setTransactionId(transactionSlip?.txnRefNoPos);
                  }}
                  className="textDiv"> <span className="textLight">Pos transaction reference No. - </span> <span className="textDark">{transactionSlip.txnRefNoPos}</span></div>
                ) : (
                  <></>
                )}
                <div  className="textDiv">
                <span className="textLight">Remarks -  </span> <span className="textDark">{transactionSlip?.description ||
                    transactionSlip?.remarks ||
                    "NA"}</span></div>
              </div>
            </div>
          </div>
          <div style={{ marginLeft: "87%", marginTop: "40px" }}>
            <SvgImage name="AppLogo" />
          </div>
        </ModalBody>
      </Modal>
      <ImageModal
            toggle={toggleImageModal}
            imageModal={imageModal}
            setImageModal={setImageModal}
            image={imageUrl.split('?')[0]}
           
          />
    </div>
  );
}

export default TransactionSlip;
